import { render, staticRenderFns } from "./PreselectTemplateCard.vue?vue&type=template&id=2ecaca54"
import script from "./PreselectTemplateCard.vue?vue&type=script&lang=ts"
export * from "./PreselectTemplateCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports